<template>
    <TableOfContents
        class="course-toc"
        :header="course.title"
        headerIcon="graduation-cap"
        :disabled="isDemo"
        v-if="remappedVideoTimeLinks.length > 0"
    >
        <VideoTimeLinksItem
            v-for="(item, index) in remappedVideoTimeLinks"
            :key="index"
            :time="item.time"
            :title="item.title"
            :sequence="item.sequence"
            :isLast="item.isLast"
            :disabled="isDemo"
            :timeItemIndex="index"
            :videoDuration="videoDuration"
            :allCurrentlyWatchedSequences="allCurrentlyWatchedSequences"
            :videoTimeCompleted="item.watched"
        />
    </TableOfContents>
</template>

<script>
    import { mapGetters } from 'vuex'
    import VideoTimeLinksItem from 'components/coursepage/videotimelinks/VideoTimeLinksItem'
    import TableOfContents from 'components/coursepage/tableofcontents/TableOfContents'

    export default {
        name: 'SingleCourseTableOfContents',
        components: {
            VideoTimeLinksItem,
            TableOfContents,
        },
        props: {
            videoTimeLinks: {
                type: Array,
                default: () => []
            },
            course: Object,
            canCourseTestBeOpen: Boolean,
            courseWithoutTestCompleted: Boolean
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                allCurrentlyWatchedSequences: 'VideoPlayer/allWatchedSequences',
                embedType: 'VideoPlayer/embedType',
                videoDuration: 'VideoPlayer/videoDuration',
                isDemo: 'VideoPlayer/showOnlyDemo',
            }),
            remappedVideoTimeLinks () {
                return this.videoTimeLinks.map((videoLink, index) => {
                    if (!this.isLinkToVideo(videoLink)) {
                        return videoLink
                    }
                    const nextLink = this.videoTimeLinks.find((el, elIndex) => {
                        return this.isLinkToVideo(el) && elIndex > index
                    })

                    if (nextLink) {
                        return {
                            ...videoLink,
                            sequence: [
                                this.convertTimeToSeconds(videoLink.time),
                                this.convertTimeToSeconds(nextLink.time) - 1
                            ]
                        }
                    } else {
                        return {
                            ...videoLink,
                            sequence: [
                                this.convertTimeToSeconds(videoLink.time),
                                this.videoDuration || 99999999999999
                            ]
                        }
                    }
                })
            }
        },
        methods: {
            isLinkToVideo (timeLink) {
                return timeLink.time !== ''
            },
            convertTimeToSeconds (time) {
                let splittedTime = time.split(':')
                let hoursInseconds = (parseInt(splittedTime[0]) * 60 * 60)
                let minutesInseconds = (parseInt(splittedTime[1]) * 60)
                let seconds = parseInt(splittedTime[2])
                return hoursInseconds + minutesInseconds + seconds
            },
        }
    }

</script>
